import { useProductImages } from '../hooks/useProductImages';

type CarouselGaleryCursorProps = { children: React.ReactNode };

const CarouselGaleryCursor = ({ children }: CarouselGaleryCursorProps) => {
	const { thumbnailVisibility = 'visible', thumbnailsOrientation = 'vertical' } = useProductImages();

	const renderTokens = () => {
		if (thumbnailVisibility === 'visible' && thumbnailsOrientation === 'vertical') {
			return 'ml-20-ns w-80-ns pl5-ns';
		}
	};

	return (
		<div
			className={`carouselGaleryCursor w-100 border-box vtex-store-components-3-x-carouselGaleryCursor ${renderTokens()}`}
		>
			{children}
		</div>
	);
};

export default CarouselGaleryCursor;
